import useUserAttributes from "@/users/useUserAttributes";
import { TabSelectorForContentPromotionVenue } from "../PromotedAtYourVenuePage/types";
import ContentPromotionDataContainer from "../ContentPromotionDataContainer";

const PromotedAtYourDistrictContainer = () => {
  // Though the "useUserAttributes" hook is deprecated, we use it here to retrieve a user's districts.
  // When a new API is created that returns this district data, we'll refactor this fetch to use it.
  // Also, until the UI is updated to accommodate for a multi-district listing, the
  // client will use the first district in the response to retrieve content-promotion data.
  const userAttributesData: Record<string, any> = useUserAttributes();
  const { userAttributes, loadingUserAttributes: isLoadingUserAttributes } =
    userAttributesData;
  const { district_ids: districtIds = [] } = userAttributes || {};
  const districtUniqueId = districtIds?.[0] || null;

  return (
    <ContentPromotionDataContainer
      districtUniqueId={districtUniqueId}
      selector={TabSelectorForContentPromotionVenue.district}
      isVenueDataLoading={isLoadingUserAttributes}
    />
  );
};

export default PromotedAtYourDistrictContainer;
